/**
 * Recursively extracts all URLs from tree view items
 * @param {Array} items - Tree view items array
 * @returns {Set<string>} - Set of all URLs found in the tree view
 */
export const extractUrlsFromTreeView = (items) => {
    const urls = new Set();
    
    if (!items || !Array.isArray(items)) {
        return urls;
    }
    
    const extractFromItem = (item) => {
        if (!item) return;
        
        // Add the item's path if it exists
        if (item.path) {
            // Normalize the path (remove query params, lowercase)
            const normalizedPath = item.path.split('?')[0].toLowerCase();
            urls.add(normalizedPath);
        }
        
        // Recursively process child items
        if (item.items && Array.isArray(item.items) && item.items.length > 0) {
            item.items.forEach(extractFromItem);
        }
    };
    
    items.forEach(extractFromItem);
    
    return urls;
};
